// extracted by mini-css-extract-plugin
export default {"content":"Efficiency_content__V-N8f"};